export default "__VITE_ASSET__BKemshqJ__"